import styled from 'styled-components';
import { Slider } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Slider) `
  && {
    .MuiSlider-rail {
      background: ${theme.colors.buttonBackgroundHover};
    }

    .MuiSlider-track {
      background: ${theme.colors.buttonBackgroundActive};
      border-color: ${theme.colors.buttonBackgroundActive};
    }

    .MuiSlider-thumb {
      background: ${theme.colors.buttonBackgroundHover};

      &:hover {
        box-shadow: 0 0 0 8px rgba(78, 68, 117, 0.16);
      }

      &.Mui-active {
        box-shadow: 0 0 0 14px rgba(78, 68, 117, 0.16);
      }
    }
  }
`;
